import Axios from 'axios';

let _is401 = false;
export default class BaseService {
  constructor() {
    this.service = Axios.create({});
    this.service.interceptors.request.use(request => {
      // if (process.env.NODE_ENV === 'development') {
      //   console.info('HttpRequest', request.data);
      // }
      return request;
    });
    this.service.interceptors.response.use(
      response => {
        if (process.env.NODE_ENV === 'development') {
          //console.info(JSON.stringify(response.data));
        }
        return response;
      },
      function (error) {
        // Do something with response error
        // console.log(JSON.stringify(error.response.data.error));
        if (error.response.status === 401 && !_is401) {
          _is401 = true;
          // console.log('401');
          localStorage.removeItem('user');
          window.location.href = '/auth/sign-in';
          alert('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại');
          _is401 = false;
        }
        return Promise.reject(error.response);
      },
    );
  }

  async post(path, payload, token) {
    if (token) {
      this.service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return this.service.request({
      method: 'POST',
      url: path,
      data: payload,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache',
        'platform': 'web',
        // 'Authorization': `Bearer ${token}`
      },
    })
  }

  async postFile(path, payload, token) {
    if (token) {
      this.service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return this.service.request({
      method: 'POST',
      url: path,
      data: payload,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Cache-Control': 'no-cache',
        'platform': 'web',
        // 'Authorization': `Bearer ${token}`
      },
    })
  }

  async put(path, payload, token) {
    if (token) {
      this.service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return this.service.request({
      method: 'PUT',
      url: path,
      data: payload,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache',
        'platform': 'web',
        // 'Authorization': `Bearer ${token}`
      },
    })
  }

  async get(path, token) {
    if (token) {
      this.service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return this.service.request({
      method: 'GET',
      url: path,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache',
        'platform': 'web',
        // 'Authorization': `Bearer ${token}`
      },
    })
  }

  async delete(path, token) {
    if (token) {
      this.service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return this.service.request({
      method: 'DELETE',
      url: path,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache',
        'platform': 'web',
        // 'Authorization': `Bearer ${token}`
      },
    })
  }
}
